import { InitialState } from "state/InitialState";
import { Utils } from "utils/Utils";
import { StateTypes } from "state/types/StateTypes";

// ----------------------------------------------------------------------

export const StateActions = {};

// ACTIONS PURAS
// ----------------------------------------------------------------------

StateActions.set = (state) => ({
  state,
  type: StateTypes.reset
});

StateActions.reset = () => ({
  state: InitialState.createStateData(),
  type: StateTypes.reset
});

StateActions.setCurrentSubscriber = (current) => {
  return {
    state: {
      currentSubscriber: current
    },
    type: StateTypes.setCurrentSubscriber
  };
};

StateActions.setCurrentEdition = (current) => ({
  state: {
    currentEdition: current
  },
  type: StateTypes.setCurrentEdition
});

StateActions.isSubscriber = (isSubscriber) => ({
  state: {
    isSubscriber
  },
  type: StateTypes.isSubscriber
});

StateActions.isActiveSubscriber = (isActiveSubscriber) => ({
  state: {
    isActiveSubscriber
  },
  type: StateTypes.isActiveSubscriber
});
